type GasIconProps = {
  color?: string;
};

export default function GasIcon({ color = '#047dba' }: GasIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
      <rect style={{ fill: 'none', strokeWidth: 0 }} x="0" width="240" height="240" />
      <path
        style={{ fill: color, strokeWidth: 0 }}
        d="M230,140l-7.04-42.19c-4.6-27.59-28.47-47.81-56.44-47.81h-26.52v68.02l68.6,15.24,1.4,8.42v23.31h-5.36c-2.43-16.94-17.04-30-34.64-30s-32.2,13.06-34.64,30H44.64c-.51-3.53-1.54-6.89-3.02-10h88.38v-20h-15.33c9.52-10.62,15.33-24.64,15.33-40,0-33.08-26.92-60-60-60H10v20h60c22.06,0,40,17.94,40,40s-17.94,40-40,40H10v20c8.27,0,15,6.73,15,15s-6.73,15-15,15v20c13.93,0,25.99-8.19,31.62-20h96.77c5.63,11.81,17.68,20,31.62,20s25.99-8.19,31.62-20h28.38v-45ZM170,185c-8.27,0-15-6.73-15-15s6.73-15,15-15,15,6.73,15,15-6.73,15-15,15ZM160,101.98v-31.98h32.37c3.28,0,6.08,2.37,6.62,5.61l6.06,36.38-45.05-10.01Z"
      />
    </svg>
  );
}

GasIcon.defaultProps = {
  color: '#047dba',
};
